import type { Entity } from '@cognitoforms/model.js';

export function readEntryPath(entry: Entity | null | undefined, path: string | null | undefined): unknown {
	if (!entry || !path)
		return null;

	try {
		return entry.meta.type.getPath(path).value(entry);
	}
	catch {
		return null;
	}
}

export function readEntryText(entry: Entity | null | undefined, path: string | null | undefined): string {
	if (!entry || !path)
		return '';

	try {
		const property = entry.meta.type.getPath(path);
		const value = property.value(entry);
		if (value === null || value === undefined)
			return '';

		return (property.format ? property.format.convert(value) : String(value)).trim();
	}
	catch {
		return '';
	}
}

export function describeSubmitter(name: string, email: string): string {
	return name && email ? `${name} (${email})` : name || email;
}

export function looksLikeEmail(text: string): boolean {
	return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(text || '');
}

/**
 * Whether the session user is the person the entry is being submitted for. A missing value on either side is never
 * a match, so an unauthenticated session or an unanswered submitter selection fails closed.
 */
export function isSubmitterMatch(sessionValue: string | null | undefined, entryValue: unknown): boolean {
	const sessionText = (sessionValue || '').trim();
	const entryText = entryValue === null || entryValue === undefined ? '' : String(entryValue).trim();

	return !!sessionText && !!entryText && sessionText.toLowerCase() === entryText.toLowerCase();
}
